module.exports = __webpack_public_path__ + "img/SOUTHASIA_ANIMAL_FATS.c04a34f1.png";